import { render, staticRenderFns } from "./IconFlagFix.vue?vue&type=template&id=7082a180&"
import script from "./IconFlagFix.vue?vue&type=script&lang=js&"
export * from "./IconFlagFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports